import { CalendarToday, Mail, Search, Settings, SchoolRounded, ReceiptRounded } from '@material-ui/icons';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import GroupIcon from '@material-ui/icons/Group';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import HomeIcon from '@material-ui/icons/HomeRounded';
import HomeWorkIcon from '@material-ui/icons/HomeWorkRounded';
import EditDocumentRounded from '@material-ui/icons/';
// import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import LinkIcon from '@material-ui/icons/Link';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
// import TeamIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';

import Affiliations from '../components/Icons/Affiliations';
import CvTheque from '../components/Icons/CvTheque';
import Library from '../components/Icons/Library';
import Partenaire from '../components/Icons/Partenaire';
import Team from '../components/Icons/Team';
import Megaphone from 'components/Icons/Megaphone';
import { insertSmartField, insertTable } from 'pages/CFA/Convention/utils/services';
import FinancialTable from 'pages/CFA/Convention/components/FinancialTable';
import SpendingTable from 'pages/CFA/Convention/components/SpendingTable';
import EditDocument from 'components/Icons/EditDocument';
import ElectricalServices from 'components/Icons/ElectricalServices';

// import SettingsIcon from '@material-ui/icons/Settings';

export const ROUTES_PATH = {
  // ------------------------------------------- //
  // ----- ANNEXE ------------------------------ //
  // ------------------------------------------- //
  HOME: '/',
  SIGN_IN: '/connexion',
  GOOGLE_OAUTH: '/oauth2/google',
  LINKEDIN_OAUTH: '/oauth2/linkedin',
  SIGN_UP: '/inscription',
  CALENDLY: '/rendezvous',
  CONFIRM_SIGNUP: '/confirmUser',
  FORGOT_PWD: '/forgot_password',
  FORGOT_NEW_PWD: '/forgot_new_password/:email',
  INVITE_EXTERNAL: '/invite/external/:id',
  SHARE_CLASSROOM: '/etablissement/classes/partage/:link',
  OODRIVE_CALLBACK: '/oodrive/callback',
  PLAYGROUND: '/playground',

  // SUBSCRIPTIONS
  UPGRADE_ACCOUNT: '/createSubscription',
  STOP_SUBSCRIPTION: '/stopSubscription',
  REACTIVATE_SUBSCRIPTION: '/reactivateSubscription',

  // ------------------------------------------- //
  // ----- STUDENT ----------------------------- //
  // ------------------------------------------- //
  STUDENT_DASHBOARD: '/apprenant/tableau-de-bord',
  STUDENT_PROFIL: '/apprenant/profil',
  STUDENT_CV: '/apprenant/cv',
  STUDENT_PLANNING: '/apprenant/planning',
  STUDENT_SOUSCRIPTION: '/apprenant/souscription',
  STUDENT_SETTINGS: '/apprenant/parametres',
  STUDENT_CANDIDATURES: '/apprenant/candidatures',
  STUDENT_FAVORITES: '/apprenant/favoris',
  STUDENT_DOCUMENTS: '/apprenant/documents',
  MYMAP: '/apprenant/ma-recherche',
  ACCEPT_INVIT: '/student/accept/invite/:id',
  STUDENT_MESSAGES: '/apprenant/messages',
  STUDENT_NOTIFICATIONS: '/apprenant/notifications',
  STUDENT_FAQ: '/apprenant/resources',

  // ------------------------------------------- //
  // ----- SCHOOL ------------------------------ //
  // ------------------------------------------- //
  SCHOOL_DASHBOARD: '/etablissement/tableau-de-bord',
  SCHOOL_FORMATIONS_CANDIDATS: '/etablissement/formations-candidats',
  SCHOOL_VITRINE: '/etablissement/vitrine/:id?',
  EDIT_SCHOOL_VITRINE: '/etablissement/edit/vitrine',
  SCHOOL_PARTNERS: '/etablissement/partenaires',
  SCHOOL_CLASSES: '/etablissement/classes',
  STUDENT_EXCLUD: '/etablissement/classes/historique/exclu/:id',
  STUDENT_ABANDONED: '/etablissement/classes/historique/abandonne/:id',
  STUDENT_CLASS_HISTORIQUE: '/etablissement/classes/historique/apprenant',
  SCHOOL_CLASSES_DETAIL: '/etablissement/classes/:id',
  SCHOOL_SETTINGS: '/etablissement/parametres',
  SCHOOL_DOCUMENT: '/etablissement/documents',
  CVTHEQUE_SCHOOL: '/etablissement/cvtheque',
  MY_VITRINE_SCHOOL: '/etablissement/vitrine',
  SCHOOL_AFFILIATION: '/etablissement/affiliations',
  SCHOOL_MESSAGES: '/etablissement/messages',
  MAP_SCHOOL: '/etablissement/ma-recherche',
  SCHOOL_INVITE_STUDENT: '/etablissement/classes/invite/apprenant',
  SCHOOL_NOTIFICATIONS: '/etablissement/notifications',
  SCHOOL_FAQ: '/etablissement/resources',
  SCHOOL_CONNECTIONS: '/etablissement/connections',

  // ------------------------------------------- //
  // ----- BUSINESS ---------------------------- //
  // ------------------------------------------- //
  BUSINESS_VITRINE: '/entreprise/vitrine/:id?',
  BUSINESS_TEAMS: '/entreprise/equipe',
  BUSINESS_TEAMS_DETAIL: '/entreprise/equipe/:id',
  BUSINESS_DOCUMENT: '/entreprise/documents',
  CVTHEQUE_BUSINESS: '/entreprise/cvtheque',
  BUSINESS_DASHBOARD: '/entreprise/tableau-de-bord',
  BUSINESS_ANNONCES_CANDIDATS: '/entreprise/emplois-candidats',
  MY_VITRINE_BUSINESS: '/entreprise/vitrine',
  BUSINESS_PARTNERS: '/entreprise/partenaires',
  BUSINESS_SETTINGS: '/entreprise/parametres',
  BUSINESS_AFFILIATION: '/entreprise/affiliations',
  EDIT_Business_VITRINE: '/entreprise/edit/vitrine',
  BUSINESS_MESSAGES: '/entreprise/messages',
  MAP_BUSINESS: '/entreprise/ma-recherche',
  BUSINESS_INVITE_STUDENT: '/entreprise/equipe/invite/apprenant',
  BUSINESS_STUDENT_EXCLUD: '/entreprise/equipe/exclu/:id',
  BUSINESS_STUDENT_ABANDONED: '/entreprise/equipe/abandonne/:id',
  BUSINESS_STUDENT_HISTORIQUE: '/entreprise/equipe/historique/apprenant',
  BUSINESS_NOTIFICATIONS: '/entreprise/notifications',
  BUSINESS_FAQ: '/entreprise/resources',

  // ------------------------------------------- //
  // ----- CFA --------------------------------- //
  // ------------------------------------------- //
  MAP_CFA: '/cfa/ma-recherche',
  CFA_DASHBOARD: '/cfa/tableau-de-bord',
  CFA_ORGANISMES: '/cfa/organismes',
  CFA_ACCOUNTING: '/cfa/comptabilite',
  CFA_RECORDS: '/cfa/dossiers',
  CFA_CONTRACT: '/cfa/convention-de-formation',
  CFA_SETTINGS: '/cfa/parametres',
  CFA_FAQ: '/cfa/besoin-aide',
  CFA_NOTIFICATIONS: '/cfa/notifications',
  CFA_MESSAGES: '/cfa/messages',
};

export const schoolMenu = [
  {
    name: 'Postuler',
    icon: Search,
    link: ROUTES_PATH.MAP_SCHOOL,
    exclude: true,
  },
  {
    name: 'Tableau de bord',
    icon: HomeIcon,
    link: ROUTES_PATH.SCHOOL_DASHBOARD,
  },
  {
    name: 'Vitrine',
    icon: HomeWorkIcon,
    link: ROUTES_PATH.EDIT_SCHOOL_VITRINE,
    altLinks: [ROUTES_PATH.MY_VITRINE_SCHOOL, ROUTES_PATH.SCHOOL_VITRINE],
    // link: ROUTES_PATH.MY_VITRINE_SCHOOL,
    // altLinks: [ROUTES_PATH.SCHOOL_VITRINE],
  },
  {
    name: 'Formations & Candidats',
    icon: Megaphone,
    link: ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS,
  },
  {
    name: 'CVthèque',
    icon: CvTheque,
    link: ROUTES_PATH.CVTHEQUE_SCHOOL,
  },
  {
    name: 'Affiliations',
    icon: Affiliations,
    link: ROUTES_PATH.SCHOOL_AFFILIATION,
  },
  {
    name: 'Connections',
    icon: ElectricalServices,
    link: ROUTES_PATH.SCHOOL_CONNECTIONS,
    restriction: ["2c9280868604cc73018709707ff200b0", "4028fe819715c535019715cd00d40001", "4028abb57ea8473c017ea84e7279001b"]
  },
  {
    name: 'Partenaires',
    icon: Partenaire,
    link: ROUTES_PATH.SCHOOL_PARTNERS,
  },
  {
    name: 'Classes',
    icon: Team,
    link: ROUTES_PATH.SCHOOL_CLASSES,
    altLinks: [ROUTES_PATH.STUDENT_CLASS_HISTORIQUE, ROUTES_PATH.STUDENT_EXCLUD, ROUTES_PATH.STUDENT_ABANDONED, ROUTES_PATH.SCHOOL_INVITE_STUDENT],
  },
  {
    name: 'Documents',
    icon: FolderSharedIcon,
    link: ROUTES_PATH.SCHOOL_DOCUMENT,
  },
  {
    name: "Ressources",
    icon: Library,
    link: ROUTES_PATH.SCHOOL_FAQ,
  },
  {
    name: 'Paramètres',
    icon: Settings,
    link: ROUTES_PATH.SCHOOL_SETTINGS,
    exclude: true,
  },
];

export const schoolMenuFree = [
  {
    name: 'Postuler',
    icon: Search,
    link: ROUTES_PATH.MAP_SCHOOL,
    exclude: true,
  },
  {
    name: 'Tableau de bord',
    icon: HomeIcon,
    link: ROUTES_PATH.SCHOOL_DASHBOARD,
  },
  {
    name: 'Vitrine',
    icon: HomeWorkIcon,
    link: ROUTES_PATH.EDIT_SCHOOL_VITRINE,
    altLinks: [ROUTES_PATH.MY_VITRINE_SCHOOL, ROUTES_PATH.SCHOOL_VITRINE],
    // link: ROUTES_PATH.MY_VITRINE_SCHOOL,
    // altLinks: [ROUTES_PATH.SCHOOL_VITRINE],
  },
  {
    name: 'Formations & Candidats',
    icon: Megaphone,
    link: ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS,
  },
  {
    name: 'CVthèque',
    icon: CvTheque,
    link: `${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Affiliations',
    icon: Affiliations,
    link: `${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Connections',
    icon: ElectricalServices,
    link: `${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`,
    disabled: true,
    restriction: ["2c9280868604cc73018709707ff200b0"]
  },
  {
    name: 'Partenaires',
    icon: Partenaire,
    link: `${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Classes',
    icon: Team,
    link: `${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Documents',
    icon: FolderSharedIcon,
    link: `${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: "Ressources",
    icon: Library,
    link: ROUTES_PATH.SCHOOL_FAQ,
  },
  {
    name: 'Paramètres',
    icon: Settings,
    link: ROUTES_PATH.SCHOOL_SETTINGS,
    exclude: true,
  },
];

export const studentMenu = [
  {
    name: 'Postuler',
    icon: Search,
    link: ROUTES_PATH.MYMAP,
    exclude: true,
  },
  {
    name: 'Tableau de bord',
    icon: HomeIcon,
    link: ROUTES_PATH.STUDENT_DASHBOARD,
  },
  {
    name: 'Profil',
    icon: PersonIcon,
    link: ROUTES_PATH.STUDENT_PROFIL,
  },
  {
    name: 'Candidatures',
    icon: FindInPageIcon,
    link: ROUTES_PATH.STUDENT_CANDIDATURES,
  },
  {
    name: 'Favoris',
    icon: FavoriteIcon,
    link: ROUTES_PATH.STUDENT_FAVORITES,
  },
  {
    name: 'Souscriptions',
    icon: Mail,
    link: ROUTES_PATH.STUDENT_SOUSCRIPTION,
  },
  {
    name: 'Planning',
    icon: CalendarToday,
    link: ROUTES_PATH.STUDENT_PLANNING,
  },
  {
    name: 'Documents',
    icon: FolderSharedIcon,
    link: ROUTES_PATH.STUDENT_DOCUMENTS,
  },
  {
    name: "Ressources",
    icon: Library,
    link: ROUTES_PATH.STUDENT_FAQ,
  },
  {
    name: 'Paramètres',
    icon: Settings,
    link: ROUTES_PATH.STUDENT_SETTINGS,
    exclude: true,
  },
];

export const cfaMenu = [
  { name: 'Postuler', icon: Search, link: ROUTES_PATH.MAP_CFA, exclude: true },
  { name: 'Tableau de bord', icon: HomeIcon, link: ROUTES_PATH.CFA_DASHBOARD },
  { name: 'Organismes de formation', icon: SchoolRounded, link: ROUTES_PATH.CFA_ORGANISMES },
  { name: 'Dossiers OPCO', icon: FolderSharedIcon, link: ROUTES_PATH.CFA_RECORDS },
  { name: 'Convention de formation', icon: EditDocument, link: ROUTES_PATH.CFA_CONTRACT },
  { name: 'Comptabilité', icon: ReceiptRounded, link: ROUTES_PATH.CFA_ACCOUNTING },
  { name: 'Resources', icon: Library, link: ROUTES_PATH.CFA_FAQ },
  { name: 'Paramètres', icon: Settings, link: ROUTES_PATH.CFA_SETTINGS, exclude: true },
]

export const businessMenu = [
  {
    name: 'Postuler',
    icon: Search,
    link: ROUTES_PATH.MAP_BUSINESS,
    exclude: true,
  },
  {
    name: 'Tableau de bord',
    icon: HomeIcon,
    link: ROUTES_PATH.BUSINESS_DASHBOARD,
  },
  {
    name: 'Vitrine',
    icon: HomeWorkIcon,
    link: ROUTES_PATH.EDIT_Business_VITRINE,
    altLinks: [ROUTES_PATH.BUSINESS_VITRINE, ROUTES_PATH.MY_VITRINE_BUSINESS],
    // link: ROUTES_PATH.MY_VITRINE_BUSINESS,
    // altLinks: [ROUTES_PATH.BUSINESS_VITRINE],
  },
  {
    name: 'Emplois & Candidats',
    icon: Megaphone,
    link: ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS,
  },
  {
    name: 'CVthèque',
    icon: CvTheque,
    link: ROUTES_PATH.CVTHEQUE_BUSINESS,
  },
  {
    name: 'Affiliations',
    icon: Affiliations,
    link: ROUTES_PATH.BUSINESS_AFFILIATION,
  },
  {
    name: 'Partenaires',
    icon: Partenaire,
    link: ROUTES_PATH.BUSINESS_PARTNERS,
  },
  {
    name: 'Equipes',
    icon: Team,
    link: ROUTES_PATH.BUSINESS_TEAMS,
    altLinks: [ROUTES_PATH.BUSINESS_STUDENT_HISTORIQUE, ROUTES_PATH.BUSINESS_STUDENT_ABANDONED, ROUTES_PATH.BUSINESS_STUDENT_EXCLUD, ROUTES_PATH.BUSINESS_INVITE_STUDENT, ROUTES_PATH.BUSINESS_TEAMS_DETAIL],
  },
  {
    name: 'Documents',
    icon: FolderSharedIcon,
    link: ROUTES_PATH.BUSINESS_DOCUMENT,
  },
  {
    name: "Ressources",
    icon: Library,
    link: ROUTES_PATH.BUSINESS_FAQ,
  },
  {
    name: 'Paramètres',
    icon: Settings,
    link: ROUTES_PATH.BUSINESS_SETTINGS,
    exclude: true,
  },
];

export const businessMenuFree = [
  {
    name: 'Postuler',
    icon: Search,
    link: ROUTES_PATH.MAP_BUSINESS,
    exclude: true,
  },
  {
    name: 'Tableau de bord',
    icon: HomeIcon,
    link: ROUTES_PATH.BUSINESS_DASHBOARD,
  },
  {
    name: 'Vitrine',
    icon: HomeWorkIcon,
    link: ROUTES_PATH.EDIT_Business_VITRINE,
    altLinks: [ROUTES_PATH.BUSINESS_VITRINE, ROUTES_PATH.MY_VITRINE_BUSINESS],
    // link: ROUTES_PATH.MY_VITRINE_BUSINESS,
    // altLinks: [ROUTES_PATH.BUSINESS_VITRINE],
  },
  {
    name: 'Emplois & Candidats',
    icon: Megaphone,
    link: ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS,
  },
  {
    name: 'CVthèque',
    icon: CvTheque,
    link: `${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Affiliations',
    icon: Affiliations,
    link: `${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Partenaires',
    icon: Partenaire,
    link: `${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Equipes',
    icon: Team,
    link: `${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: 'Documents',
    icon: FolderSharedIcon,
    link: `${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`,
    disabled: true,
  },
  {
    name: "Ressources",
    icon: Library,
    link: ROUTES_PATH.BUSINESS_FAQ,
  },
  {
    name: 'Paramètres',
    icon: Settings,
    link: ROUTES_PATH.BUSINESS_SETTINGS,
    exclude: true,
  },
];

export const profiles = [
  { title: 'Oui', value: true },
  { title: 'Non', year: false },
];

export const levels = [
  { title: 'BTS', value: 'bts' },
  { title: 'Licence', value: 'licence' },
];

export const locations = [
  { title: 'Marseille 13002', value: '13002' },
  { title: 'Paris 75000', value: '75000' },
];

export const admissionRequirements = [
  { title: 'BAC obtenu', value: 'bac' },
  { title: 'Brevet obtenu', value: 'brevet' },
  { title: 'Licence obtenu', value: 'licence' },
];

export const recognitionDegrees = [
  { title: "Reconnu par l'état", value: 'etat' },
];

export const durations = [
  { title: '3 trimestres', value: '3' },
  { title: '6 trimestres', value: '6' },
];

export const schoolRhythms = [
  { title: 'En continue', value: 'enContinue' },
  { title: 'A distance', value: 'distance' },
];

export const langs = [
  { title: 'Français', value: 'FR' },
  { title: 'Anglais', value: 'EN' },
];

export const ACCESSES = {
  STUDENT: 'INDIVIDUAL',
  BUSINESS: 'BUSINESS',
  SCHOOL: 'SCHOOL',
  CFA: 'CFA',
};

export const PERMIS_TYPE = [
  {
    value: 'AM',
    label: 'AM',
  },
  {
    value: 'A',
    label: 'A',
  },
  {
    value: 'A1',
    label: 'A1',
  },
  {
    value: 'A2',
    label: 'A2',
  },
  {
    value: 'B',
    label: 'B',
  },
  {
    value: 'B1',
    label: 'B1',
  },
  {
    value: 'BE',
    label: 'BE',
  },
  {
    value: 'C',
    label: 'C',
  },
  {
    value: 'C1',
    label: 'C1',
  },
  {
    value: 'C1E',
    label: 'C1E',
  },
  {
    value: 'D',
    label: 'D',
  },
  {
    value: 'D1',
    label: 'D1',
  },
  {
    value: 'D1E',
    label: 'D1E',
  },
  {
    value: 'DE',
    label: 'DE',
  },
  {
    value: 'R482',
    label: 'R482',
  },
  {
    value: 'R483',
    label: 'R483',
  },
  {
    value: 'R484',
    label: 'R484',
  },
  {
    value: 'R485',
    label: 'R485',
  },
  {
    value: 'R486',
    label: 'R486',
  },
  {
    value: 'R487',
    label: 'R487',
  },
  {
    value: 'R489',
    label: 'R489',
  },
  {
    value: 'R490',
    label: 'R490',
  },
];

export const RYTHME_SCOLAIRE = [
  {
    value: '1daySchool4daysBusiness',
    label: '1 jour en cours / 4 jours en entreprise',
  },
  {
    value: '2daysSchool3daysBusiness',
    label: '2 jours en cours / 3 jours en entreprise',
  },
  {
    value: '1weekSchool1weekBusiness',
    label: '1 semaine en cours / 1 semaine en entreprise',
  },
  {
    value: '2weekSchool3weekBusiness',
    label: '2 semaine en cours / 3 semaine en entreprise',
  },
  {
    value: '6weekSchool6weekBusiness',
    label: '6 semaine en cours / 6 semaine en entreprise',
  },
];

export const KNOW_US = [
  { value: 'Moteur de recherche (Google, Bing...)', label: 'Moteur de recherche (Google, Bing...)' },
  { value: 'Réseaux sociaux (LinkedIn, Facebook...)', label: 'Réseaux sociaux (LinkedIn, Facebook...)' },
  { value: 'Publicité en ligne', label: 'Publicité en ligne' },
  { value: 'Bouche à oreille', label: 'Bouche à oreille' },
  { value: 'Blog ou publication', label: 'Blog ou publication' },
  { value: 'Évènement', label: 'Évènement' },
  { value: 'Autre', label: 'Autre' },
]

export const DEPARTMENTS = [
  { label: 'Ain', value: '01' },
  { label: 'Aisne', value: '02' },
  { label: 'Allier', value: '03' },
  { label: 'Alpes-de-Haute-Provence', value: '04' },
  { label: 'Hautes-Alpes', value: '05' },
  { label: 'Alpes-Maritimes', value: '06' },
  { label: 'Ardèche', value: '07' },
  { label: 'Ardennes', value: '08' },
  { label: 'Ariège', value: '09' },
  { label: 'Aube', value: '10' },
  { label: 'Aude', value: '11' },
  { label: 'Aveyron', value: '12' },
  { label: 'Bouches-du-Rhône', value: '13' },
  { label: 'Calvados', value: '14' },
  { label: 'Cantal', value: '15' },
  { label: 'Charente', value: '16' },
  { label: 'Charente-Maritime', value: '17' },
  { label: 'Cher', value: '18' },
  { label: 'Corrèze', value: '19' },
  { label: 'Côte-d\'Or', value: '21' },
  { label: 'Côtes-d\'Armor', value: '22' },
  { label: 'Creuse', value: '23' },
  { label: 'Dordogne', value: '24' },
  { label: 'Doubs', value: '25' },
  { label: 'Drôme', value: '26' },
  { label: 'Eure', value: '27' },
  { label: 'Eure-et-Loir', value: '28' },
  { label: 'Finistère', value: '29' },
  { label: 'Corse-du-Sud', value: '2A' },
  { label: 'Haute-Corse', value: '2B' },
  { label: 'Gard', value: '30' },
  { label: 'Haute-Garonne', value: '31' },
  { label: 'Gers', value: '32' },
  { label: 'Gironde', value: '33' },
  { label: 'Hérault', value: '34' },
  { label: 'Ille-et-Vilaine', value: '35' },
  { label: 'Indre', value: '36' },
  { label: 'Indre-et-Loire', value: '37' },
  { label: 'Isère', value: '38' },
  { label: 'Jura', value: '39' },
  { label: 'Landes', value: '40' },
  { label: 'Loir-et-Cher', value: '41' },
  { label: 'Loire', value: '42' },
  { label: 'Haute-Loire', value: '43' },
  { label: 'Loire-Atlantique', value: '44' },
  { label: 'Loiret', value: '45' },
  { label: 'Lot', value: '46' },
  { label: 'Lot-et-Garonne', value: '47' },
  { label: 'Lozère', value: '48' },
  { label: 'Maine-et-Loire', value: '49' },
  { label: 'Manche', value: '50' },
  { label: 'Marne', value: '51' },
  { label: 'Haute-Marne', value: '52' },
  { label: 'Mayenne', value: '53' },
  { label: 'Meurthe-et-Moselle', value: '54' },
  { label: 'Meuse', value: '55' },
  { label: 'Morbihan', value: '56' },
  { label: 'Moselle', value: '57' },
  { label: 'Nièvre', value: '58' },
  { label: 'Nord', value: '59' },
  { label: 'Oise', value: '60' },
  { label: 'Orne', value: '61' },
  { label: 'Pas-de-Calais', value: '62' },
  { label: 'Puy-de-Dôme', value: '63' },
  { label: 'Pyrénées-Atlantiques', value: '64' },
  { label: 'Hautes-Pyrénées', value: '65' },
  { label: 'Pyrénées-Orientales', value: '66' },
  { label: 'Bas-Rhin', value: '67' },
  { label: 'Haut-Rhin', value: '68' },
  { label: 'Rhône', value: '69' },
  { label: 'Haute-Saône', value: '70' },
  { label: 'Saône-et-Loire', value: '71' },
  { label: 'Sarthe', value: '72' },
  { label: 'Savoie', value: '73' },
  { label: 'Haute-Savoie', value: '74' },
  { label: 'Paris', value: '75' },
  { label: 'Seine-Maritime', value: '76' },
  { label: 'Seine-et-Marne', value: '77' },
  { label: 'Yvelines', value: '78' },
  { label: 'Deux-Sèvres', value: '79' },
  { label: 'Somme', value: '80' },
  { label: 'Tarn', value: '81' },
  { label: 'Tarn-et-Garonne', value: '82' },
  { label: 'Var', value: '83' },
  { label: 'Vaucluse', value: '84' },
  { label: 'Vendée', value: '85' },
  { label: 'Vienne', value: '86' },
  { label: 'Haute-Vienne', value: '87' },
  { label: 'Vosges', value: '88' },
  { label: 'Yonne', value: '89' },
  { label: 'Territoire de Belfort', value: '90' },
  { label: 'Essonne', value: '91' },
  { label: 'Hauts-de-Seine', value: '92' },
  { label: 'Seine-Saint-Denis', value: '93' },
  { label: 'Val-de-Marne', value: '94' },
  { label: 'Val-d\'Oise', value: '95' },
  { label: 'Guadeloupe', value: '971' },
  { label: 'Martinique', value: '972' },
  { label: 'Guyane', value: '973' },
  { label: 'La Réunion', value: '974' },
  { label: 'Mayotte', value: '976' },
  { label: 'Réside à l\'étranger', value: '099' },
];

export const SITUATION_BEFORE_CONTRACT = [
  { label: 'Scolaire', value: '1' },
  { label: 'Prépa apprentissage', value: '2' },
  { label: 'Etudiant', value: '3' },
  { label: 'Contract d\'apprentissage', value: '4' },
  { label: 'Contrat de professionnalisation', value: '5' },
  { label: 'Contrat aidé', value: '6' },
  { label: 'En formation au CFA avant signature d\'un contrat d\'apprentissage (L6222-12-1 du code du travail)', value: '7' },
  { label: 'En formation, au CFA, sans contrat, suite à rupture (5° de L6231-2 du code du travail)', value: '8' },
  { label: 'Stagiaire de la formation professionnelle', value: '9' },
  { label: 'Salarié', value: '10' },
  { label: 'Personne à la recherche d’un emploi (inscrite ou non au Pôle Emploi)', value: '11' },
  { label: 'Inactif', value: '12' },
];

export const LAST_DISPLOMA = [
  { label: 'Aucun diplôme ni titre professionnel', value: '13' },
  { label: 'Certificat de formation générale', value: '26' },
  { label: 'Diplôme national du Brevet (DNB)', value: '25' },
  { label: 'CAP', value: '33' },
  { label: 'BEP', value: '34' },
  { label: 'Mention complémentaire', value: '35' },
  { label: 'Autre diplôme ou titre de niveau CAP/BEP', value: '38' },
  { label: 'Baccalauréat professionnel', value: '41' },
  { label: 'Baccalauréat général', value: '42' },
  { label: 'Baccalauréat technologique', value: '43' },
  { label: 'Autre diplôme ou titre de niveau bac', value: '49' },
  { label: 'Brevet de Technicien Supérieur', value: '54' },
  { label: 'Diplôme Universitaire de technologie', value: '55' },
  { label: 'Autre diplôme ou titre de niveau bac+2', value: '58' },
  { label: '1ère année de Master', value: '61' },
  { label: 'Licence professionnelle', value: '62' },
  { label: 'Licence générale', value: '63' },
  { label: 'Autre diplôme ou titre de niveau bac+3 ou 4', value: '69' },
  { label: 'Master professionnel/DESS', value: '71' },
  { label: 'Master recherche/DEA', value: '72' },
  { label: 'Master indifférencié', value: '73' },
  { label: 'Diplôme d\'ingénieur, diplôme d\'école de commerce', value: '74' },
  { label: 'Autre diplôme ou titre de niveau bac+5 ou plus', value: '79' },
  { label: 'Doctorat', value: '80' },
]

export const LAST_DIPLOMA_YEAR = [
  { label: 'L\'apprenti a suivi la dernière année du cycle de formation et a obtenu le diplôme ou titre', value: '1' },
  { label: 'L\'apprenti a suivi la 1ère année du cycle et l\'a validée (examens réussis mais année non diplômante)', value: '11' },
  { label: 'L\'apprenti a suivi la 1ère année du cycle mais ne l\'a pas validée (échec aux examens, interruption ou abandon de formation)', value: '12' },
  { label: 'L\'apprenti a suivi la 2è année du cycle et l\'a validée (examens réussis mais année non diplômante)', value: '21' },
  { label: 'L\'apprenti a suivi la 2è année du cycle mais ne l\'a pas validée (échec aux examens, interruption ou abandon de formation)', value: '22' },
  { label: 'L\'apprenti a suivi la 3è année du cycle et l\'a validée (examens réussis mais année non diplômante, cycle adapté)', value: '31' },
  { label: 'L\'apprenti a suivi la 3è année du cycle mais ne l\'a pas validée (échec aux examens, interruption ou abandon de formation)', value: '32' },
  { label: 'L\'apprenti a achevé le 1er cycle de l\'enseignement secondaire (collège)', value: '40' },
  { label: 'L\'apprenti a interrompu ses études en classe de 3è', value: '41' },
  { label: 'L\'apprenti a interrompu ses études en classe de 4è', value: '42' },
]

export const BEST_DIPLOMA = [
  { label: 'CAP, BEP', value: '3' },
  { label: 'Baccalauréat', value: '4' },
  { label: 'DEUG, BTS, DUT, DEUST', value: '5' },
  { label: 'Licence, licence professionnelle, BUT, Maîtrise', value: '6' },
  { label: 'Master, diplôme d\'études approfondies, dip^lome d\'études supérieures spécialisées, diplôme d\'ingénieur', value: '7' },
  { label: 'Doctorat, habilitation à diriger des recherches', value: '8' },
  { label: 'Aucun', value: '0' }
]

export const EMPLOYER_TYPE = [
  { label: 'Entreprise inscrite au répertoire des métiers ou au registre des entreprises pour l\'Alsace-Moselle', value: '11' },
  { label: 'Entreprise inscrite uniquement au registre du commerce et des sociétés', value: '12' },
  { label: 'Entreprises dont les salariés relèvent de la mutualité sociale agricole', value: '13' },
  { label: 'Profession libérale', value: '14' },
  { label: 'Association', value: '15' },
  { label: 'Autre employeur privé', value: '16' },
  { label: 'Service de l\'Etat (administrations centrales et leurs services déconcentrés de la fonction publique d\'Etat)', value: '21' },
  { label: 'Commune', value: '22' },
  { label: 'Département', value: '23' },
  { label: 'Région', value: '24' },
  { label: 'Etablissement public hospitalier', value: '25' },
  { label: 'Etablissement public local d\'enseignement', value: '26' },
  { label: 'Etablissement public administratif de l\'Etat', value: '27' },
  { label: 'Etablissement public administratif local(y compris établissement public de coopération intercommunale EPCI)', value: '28' },
  { label: 'Autre employeur public', value: '29' },
];

export const SPECIFIC_EMPLOYER = [
  { label: 'Entreprise de travail temporaire', value: "1" },
  { label: 'Groupement d\'employeurs', value: "2" },
  { label: 'Employeur saisonnier', value: "3" },
  { label: 'Apprentissage familial : l\'employeur est un ascendant de l\'apprenti', value: "4" },
  { label: 'Aucun de ces cas', value: "0" },
];

export const CONTRACTUAL_MODE = [
  { label: 'A durée limitée', value: "1" },
  { label: 'Dans le cadre d\'un CDI', value: "2" },
  { label: 'Entreprise de travail temporaire', value: "3" },
  { label: 'Activités saisonnières à deux employeurs', value: "4" },
];

export const OPCO_CONTRACT_TYPE = [
  { label: 'Premier contrat d\'apprentissage de l\'apprenti', value: '11' },
  { label: 'Nouveau contrat avec un apprenti qui a terminé son précédent contrat auprès d\'un même employeur', value: '21' },
  { label: 'Nouveau contrat avec un apprenti qui a terminé son précédent contrat auprès d\'un autre employeur', value: '22' },
  { label: 'Nouveau contrat avec un apprenti dont le précédent contrat auprès d\'un autre employeur a été rompu', value: '23' },
  { label: 'Modification de la situation juridique de l\'employeur', value: '31' },
  { label: 'Changement d\'employeur dans le cadre d\'un contrat saisonnier', value: '32' },
  { label: 'Prolongation du contrat suite à un échec à l\'examen de l\'apprenti', value: '33' },
  { label: 'Prolongation du contrat suite à la reconnaissance de l\'apprenti comme travailleur handicapé', value: '34' },
  { label: 'Modification du diplôme préparé par l\'apprenti', value: '35' },
  { label: 'Autres changements : changement de maître d\'apprentissage, de durée de travail hebdomadaire, réduction de durée, etc.', value: '36' },
  { label: 'Modification du lieu d\'exécution du contrat', value: '37' },
  { label: 'Modification du lieu principal de réalisation de la formation théorique', value: '38' }
];

export const DEROGATION_TYPE = [
  { label: 'Age de l\'apprenti inférieur à 16 ans', value: '11' },
  { label: 'Age supérieur à 29 ans : cas spécifiques prévus dans le code du travail', value: '12' },
  { label: 'Réduction de la durée du contrat ou de la période d\'apprentissage', value: '21' },
  { label: 'Allongement de la durée du contrat ou de la période d\'apprentissage', value: '22' },
  { label: 'Cumul de dérogations', value: '50' },
  { label: 'Autre dérogation', value: '60' },
];

export const PRIVATEORPUBLIC = [
  { value: 'true', label: 'Publique' },
  { value: 'false', label: 'Privé' },
];

export const YESNO = [
  { value: 'true', label: 'Oui' },
  { value: 'false', label: 'Non' },
];

export const SEXES = [
  { label: 'Homme', value: 'M' },
  { label: 'Femme', value: 'F' },
];

export const NATIONALITY = [
  { label: 'Française', value: '1' },
  { label: 'Union Européenne', value: '2' },
  { label: 'Etranger hors Union Européenne', value: '3' },
];

export const SOCIAL_REGIME = [
  { label: 'MSA', value: '1' },
  { label: 'URSSAF', value: '2' },
]

const insertSmartFieldCall = (params) => {
  insertSmartField(params);
};

const insertTableSmartFieldCall = (params) => {
  insertTable(params);
};

export const SMART_FIELDS = [
  { label: 'Intitulé CFA', value: '[cfaName/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Adresse CFA', value: '[cfaAddress/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Siret CFA', value: '[cfaSiret/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'UAI CFA', value: '[cfaUai/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Intitulé de l\'entreprise', value: '[businessName/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Adresse de l\'entreprise', value: '[businessAddress/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Siret de l\'entreprise', value: '[businessSiret/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Employeur', value: '[employer/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'IDCC', value: '[idcc/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Intitulé de formation', value: '[formationName/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Code RNCP', value: '[rncpCode/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Code diplôme', value: '[diplomaCode/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Début formation', value: '[formationStartDate/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Fin formation', value: '[formationEndDate/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Heures formation', value: '[formationHours/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Lieu formation', value: '[formationLocation/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Maître d\'apprentissage', value: '[apprenticeMaster/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Fonction maître', value: '[apprenticeMasterFunction/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Email maître', value: '[apprenticeMasterEmail/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Téléphone maître', value: '[apprenticeMasterPhone/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Apprenti', value: '[apprentice/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Début du contrat', value: '[contractStartDate/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Fin du contrat', value: '[contractEndDate/]', type: "smartfield", insertFunction: insertSmartFieldCall },
  { label: 'Tableau financier', value: '[tableauFinancier/]', type: "table", insertFunction: insertTableSmartFieldCall, tableComponent: FinancialTable },
  { label: 'Total dépenses', value: '[totalDepenses/]', type: "table", insertFunction: insertTableSmartFieldCall, tableComponent: SpendingTable },
];

export const OPCO_STATUS_FILTERS = [
  { label: 'Transmis', value: 'TRANSMIS' },
  { label: 'Figé', value: 'FIGE' },
  { label: 'En cours de traitement', value: 'EN_COURS_INSTRUCTION' },
  { label: 'Engagé', value: 'ENGAGE' },
  { label: 'Refusé', value: 'REFUSE' },
  { label: 'Annulé', value: 'ANNULE' },
  { label: 'Solde', value: 'SOLDE' },
  { label: 'Rupture', value: 'RUPTURE' },
]

export const OPCO_STATUS = [
  { label: 'Transmis', value: 'TRANSMIS' },
  { label: 'Figé', value: 'FIGE' },
  { label: 'En cours de traitement', value: 'EN_COURS_INSTRUCTION' },
  { label: 'Engagé', value: 'ENGAGE' },
  { label: 'Refusé', value: 'REFUSE' },
  { label: 'Annulé', value: 'ANNULE' },
  { label: 'Solde', value: 'SOLDE' },
  { label: 'Rupture', value: 'RUPTURE' },
  { label: 'Erreur CERFA', value: 'ERROR-CERFA-UPLOAD' },
  { label: 'Erreur contrat', value: 'ERROR-CONTRACT-UPLOAD' },
  { label: 'Erreur convention', value: 'ERROR-CONVENTION-UPLOAD' },
  { label: 'Clé à renouveler', value: 'FORBIDDEN' },
  { label: 'Désynchronisé', value: 'UNSYNC' }
]

export const BILLING_STATUS = [
  { label: 'À venir', value: 'A_VENIR', colorValue: '#FA8100' },
  { label: 'À envoyer', value: 'CREATED', colorValue: '#C2278C' },
  { label: 'Transmises', value: 'TRANSMIS', colorValue: '#0060F9' },
  { label: 'En cours de réglement', value: 'EN_COURS_REGLEMENT', colorValue: '#8631D6' },
  { label: 'Réglé', value: 'REGLE', colorValue: '#008000' },
  { label: 'Refusé', value: 'REFUSE', colorValue: '#F50057' },
  { label: 'Annulé', value: 'ANNULE', colorValue: '#F50057' },
  { label: 'Bloqué', value: 'BLOQUE', colorValue: '#F50057' },
  { label: 'Relance', value: 'RELANCE', colorValue: '#F50057' },
]

export const CONTRACT_STATUS = [
  { label: 'En attente', value: 'SENT' },
  { label: 'Signé', value: 'ARCHIVED' },
]

export const OPCOS = [
  { label: 'Afdas', value: 'Afdas' },
  { label: 'Atlas', value: 'Atlas' },
  { label: 'Ocapiat', value: 'Ocapiat' },
  { label: 'Uniformation', value: 'Uniformation' },
  { label: 'Constructys', value: 'Constructys' },
  { label: 'Opcommerce', value: 'Opcommerce' },
  { label: 'Akto', value: 'Akto' },
  { label: 'Opco2i', value: 'Opco2i' },
  { label: 'Opco Mobilités', value: 'Opco Mobilités' },
  { label: 'Opco EP', value: 'Opco EP' },
  { label: 'Opco Santé', value: 'Opco Santé' },
];

export const cognitoError = (code) => {
  switch (code) {
    case 'ExpiredCodeException':
      return "Votre code de confirmation n'est plus valide";
    case 'AliasExistsException':
      return 'Un compte avec ces identifiants existe déjà';
    case 'CodeMismatchException':
      return 'Votre code de confirmation est invalide';
    case 'InternalErrorException':
      return 'Problème de service, merci de réessayer plus tard';
    case 'InvalidLambdaResponseException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'InvalidParameterException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'InvalidEmailRoleAccessPolicyException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'LimitExceededException':
      return "La limite d'essai a été dépassée, merci de réessayer plus tard.";
    case 'NotAuthorizedException':
      return "Vous n'etes pas autorisé à faire cet action";
    case 'ResourceNotFoundException':
      return "Votre compte n'est pas trouvé";
    case 'TooManyFailedAttemptsException':
      return "La limite d'essai a été dépassée, merci de réessayer plus tard.";
    case 'TooManyRequestsException':
      return "La limite d'essai a été dépassée, merci de réessayer plus tard.";
    case 'UnexpectedLambdaException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'ForbiddenException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'UserLambdaValidationException':
      return 'Problème de service, merci de réessayer plus tard.';
    case 'UserNotFoundException':
      return "Votre compte n'est pas trouvé";
    case 'CodeDeliveryFailureException':
      return "un problème est survenu lors de l'envoi du code";
    default:
      return 'Veuillez contacter le service technique support-technique@linkpick.fr';
  }
};

export const cfaDefaultModel = {
  "name": "Par défaut",
  "pages": [
    {
      "id": "page1",
      "text": "<div style=\"text-align: center;\"><b style=\"font-size: 20px;\">CONDITIONS PARTICULIERES DE FORMATION CONVENTION DE FORMATION POUR LA MISE EN ŒUVRE D’UN CONTRAT D’APPRENTISSAGE<br></b><div><br><div style=\"text-align: left;\"><b><u><span style=\"font-size: 16px; font-family: Roboto;\">Entre d’une part, l'organisme de Formation (également désigné « EPITECH » dans les présentes)<br></span></u></b><div><br><div>Dénomination : <font color=\"#1472ff\">EPITECH (École pour l’Informatique et les Nouvelles Technologies) \n<br></font><div><br></div></div></div><div>Association sans but lucratif, enregistrée sous le numéro 423 855 196, dont le siège social est sis au 24 rue Pasteur - 94270 Le KREMLIN\n</div><div>BICETRE, agréée comme Organisme de formation sous le n° 11 94 06738 94 auprès de la Préfecture de la région Ile-de-France et représentée \n</div><div>par <font color=\"#1472ff\">Monsieur BARDECHE Fabrice - VICE-PRÉSIDENT EXÉCUTIF. \n<br></font><div><br></div></div><div>EPITECH Organisme de formation.<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">Et d’autre part, l'Entreprise<br></span></u></b><div><br></div>  \n</div></div></div><div>Dénomination : <font color=\"#1472ff\">LINKPICK</font></div><div>Forme juridique : <font color=\"#1472ff\">NC</font></div><div>Adresse : <font color=\"#1472ff\">195 ALLEE DU CAGNARD, 13004 MARSEILLE, FRANCE</font></div><div>Lieu d’immatriculation : <font color=\"#1472ff\">NC  \n</font></div><div>Siret : <font color=\"#1472ff\">907 983 969 000 11</font></div><div>Représentée par <font color=\"#1472ff\">MONSIEUR BICHI Quentin, PRESIDENT ET CEO.  \n<br></font><div><br></div></div><div>Il est conclu la présente convention de formation par apprentissage, en application des dispositions de la partie VI du code du travail relatif \n</div><div>à la formation professionnelle tout au long de la vie, notamment ses articles L. 6353-1 et D. 6353-1.<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE I – OBJET DE LA CONVENTION<br></span></u></b><div><br></div><b><u> \n</u></b></div></div></div><div>L’Organisme de formation s’engage à dispenser l’action de formation, intitulée :<font color=\"#1472ff\"> Architecte de Systèmes d'Information</font>, titre de niveau <font color=\"#1472ff\">I / \n</font></div><div><font color=\"#1472ff\">7</font>, inscrit au RNCP sous le code formation numéro <font color=\"#1472ff\">RNCP38114</font>, code diplôme en apprentissage numéro <font color=\"#1472ff\">16X32694 </font>du <font color=\"#1472ff\">07/10/2024 </font>au \n</div><div><font color=\"#1472ff\">25/09/2026</font>, d’une durée totale de <font color=\"#1472ff\">1197 </font>heures. \n<br><div><br></div></div><div>Le programme pédagogique définissant les modalités, les objectifs et le contenu de la formation est joint en annexe aux présentes.<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE II - NATURE DE L’ACTION ET PARTICIPANTS<br></span></u></b><div><br></div><b><u>  \n</u></b></div></div></div><div>Il s’agit d’une action de formation par apprentissage conformément aux dispositions des articles L. 6313-1 4° et L. 6211-2 du code du travail.  \n<br><div><br></div></div><div>L’action de formation est organisée auprès du.de la Bénéficiaire suivant : <font color=\"#1472ff\">MONSIEUR SALMI Wassim</font>, né.e le <font color=\"#1472ff\">17/04/2001 </font>de nationalité \n</div><div><font color=\"#1472ff\">FRANCAISE </font>et demeurant <font color=\"#1472ff\">10 AVENUE DE GARLABAN -  - 13012 MARSEILLE-12E-ARRONDISSEMENT - FRANCE.&nbsp;<br></font><div><br><div>Elle est mise en œuvre dans le cadre d’un contrat d’apprentissage conclu du <font color=\"#1472ff\">07/10/2024 </font>au <font color=\"#1472ff\">25/09/2026 </font>entre le.la Bénéficiaire et \n</div></div></div><div>l'entreprise ci-dessus désignée.&nbsp;<br><div><br><div>Lorsque l’apprenti.e a commencé sa formation sous un autre statut (ex. stagiaire de la formation professionnelle au titre de l’article L.6222\n</div></div></div><div>12-1 – avant la signature du contrat ou au titre de l’article L.6231-2 - en cas de rupture de contrat) ou bien lorsque le contrat fait suite à un \n</div><div>précédent contrat d’apprentissage : préciser pour chaque période le statut, la date d’entrée en formation et le cas échéant les dates du \n</div><div>précédent contrat).&nbsp;<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE III – MISE EN OEUVRE DE LA FORMATION<br></span></u></b><div><br><div><b>3.1. Modalités de déroulement</b></div></div></div></div></div></div></div></div>"
    },
    {
      "id": "page2",
      "text": "Le cursus de la formation suivie par le.la Bénéficiaire prévoit, pendant toute la durée des études, un rythme alterné EPITECH/Entreprise du \n<div>07/10/2024 au 25/09/2026 pour une durée totale de 1197 heures selon le calendrier pédagogique joint en annexe. La formation \n</div><div>s’effectuera en présentiel. \n<br><div><br></div></div><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">3.2. Modalités de suivi et d’encadrement</span> \n</u></b><br><div><br></div></div><div>Le.la Bénéficiaire est soumis.e à l’assiduité aux cours et au respect des jours de présence en entreprise. \n<br><div><br></div></div><div>Le.la Bénéficiaire recevra, au sein d’EPITECH, une formation dont le programme détaillé, lequel précise le niveau de connaissances préalable \n</div><div>requis pour suivre la formation, ainsi que le calendrier sont joints en annexe de la présente convention. Le suivi des cours devra s’effectuer \n</div><div>dans les locaux d’EPITECH, sise  <font color=\"#1472ff\">Place Jules Guesde  - 13001 MARSEILLE - FRANCE</font>, code UAI  <font color=\"#1472ff\">0133999B</font>, conformément au dit calendrier. \n<br><div><br></div></div><div>L’Organisme de formation contrôle la présence du.de la Bénéficiaire et notifie à l’entreprise ses absences. \n<br><div><br></div></div><div>L’encadrement de l’apprenti.e en entreprise est confié à : \n</div><div><font color=\"#1472ff\">MONSIEUR BICHI Arnaud - DIRECTEUR TECHNIQUE  \n</font></div><div>Téléphone : <font color=\"#1472ff\">0612041186  \n</font></div><div>Email : <font color=\"#1472ff\">arnaud.bichi@linkpick.fr  \n</font><br><div><br></div></div><div>Il.elle sera en charge d’accueillir l’apprenti.e, de l’informer, de le.la guider, d’organiser son temps de travail et assurer la liaison avec \n</div><div>l’organisme de formation à travers les outils de suivis et d’évaluation. \n<br><div><br></div></div><div>Tout changement de maître ou maîtresse d’apprentissage en cours de contrat doit être notifié par avenant à l’organisme de formation.  \n<br><div><br></div></div><div>Le.la Bénéficiaire se voit remettre par l’Organisme de formation la documentation pédagogique nécessaire au bon déroulement de l’action \n</div><div>de formation.  \n<br><div><br></div></div><div>Afin d’assurer le bon déroulement de la formation et le respect du règlement intérieur, EPITECH se réserve le droit de convoquer le.la \n</div><div>Bénéficiaire au conseil de discipline et de prendre les sanctions nécessaires.  \n<br><div><br></div></div><div>A l'issue de ce conseil et après avoir entendu les explications du.de la Bénéficiaire, en présence des membres du conseil de discipline réunis \n</div><div>conformément au règlement intérieur, EPITECH pourra prendre des sanctions allant jusqu'à l’exclusion définitive du centre de formation</div><div>impliquant la rupture de la convention de formation.  \n<br><div><br></div></div><div>Dans tous les cas de mesure disciplinaire envisagés à l’encontre du.de la Bénéficiaire par EPITECH, l’OPCO ainsi que l’entreprise en seront \n</div><div>informés sans délai par tout moyen écrit, à chaque étape de la procédure ainsi mise en œuvre.&nbsp;<br><div><br><div><u><b><span style=\"font-size: 16px; font-family: Roboto;\">&nbsp;3.3. Modalités d’obtention du titre<br></span></b></u><div><br><div>L’Organisme de formation contrôle l’acquisition des connaissances du.de la Bénéficiaire au moyen d’un contrôle continu tel que décrit dans \r</div></div></div></div></div><div>le programme pédagogique joint en annexe.&nbsp;<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE IV : ENGAGEMENTS DE L’ORGANISME DE FORMATION<br></span></u></b><div><br><div>L’Organisme de formation s’engage à :  \r</div></div></div></div></div><div>- Assurer l’ensemble de la formation conformément aux textes régissant la formation concernée ;  \r</div><div>- Accompagner les employeur.euse.s et les apprenti.e.s dans leurs rôles, à mettre en place des procédures de suivi pédagogique et \r</div><div>d’évaluation ;  \r</div><div>- Offrir un espace de médiation pour toute difficulté rencontrée par les parties en présence (employeur.euse.s, apprenti.e.s, \r</div><div>Organisme de formation...) ; \r</div><div>- Informer l’employeur.euse et l’apprenti.e du programme et du calendrier pédagogique de la formation.&nbsp;<div><div><br></div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE V : ENGAGEMENTS DE L’EMPLOYEUR.EUSE<br></span></u></b><div><br><div>L’employeur.euse s’engage à : \r<br><div>- Inscrire l'apprenti dans l’Organisme de Formation \r</div></div></div></div><div>- Désigner pour l’apprenti.e un.e maître.sse d'apprentissage qui devra assurer les fonctions suivantes :</div><div>&nbsp; &nbsp;- Accueil de l'apprenti.e \r</div><div>&nbsp; &nbsp;- Assurer l’ensemble de la formation conformément aux textes régissant la formation concernée ;  \r</div><div>&nbsp; &nbsp;- Mettre en place un accompagnement personnalisé du parcours de formation de l’apprenti.e (évaluations, bilans \r</div><div>&nbsp; &nbsp; &nbsp;individuels...) ;&nbsp;<br><div>&nbsp; &nbsp;- S’assurer de l’assiduité de l’apprenti.e à l’établissement de formation et prendre le cas échéant, les mesures nécessaires \r</div></div><div>&nbsp; &nbsp; &nbsp;en cas d’absences injustifiées ;&nbsp;</div><div><br><div><br></div></div></div>"
    },
    {
      "id": "page3",
      "text": "&nbsp; &nbsp;- Prendre part aux activités destinées à coordonner la formation de l’Organisme de formation avec la formation pratique \r<div>&nbsp; &nbsp; &nbsp;assurée par l'entreprise ;&nbsp;<br><div>&nbsp; &nbsp;- Participer aux rencontres prévues par l’Organisme de formation. \r<br><div><br><div></div></div></div></div><span style=\"font-size: 16px; font-family: Roboto;\"><b><u><div><div><div><div>ARTICLE VI : DISPOSITIONS FINANCIERES – FACTURATION - PENALITES \r</div></div></div></div><div></div></u></b></span><div><br><div>Le prix de la formation s’élève à <font color=\"#1472ff\">20 856,00</font> € HT.</div></div><div><br><div>---<br><div>Simulation, sous réserve des informations communiquées par l’entreprise afin d’identifier le montant de PEC OPCO*. \r</div></div></div><div>* Le montant de la prise en charge étant fixé par l’OPCO, le reste a charge pourra être réévaluer en fonction de celle-ci.&nbsp;<br><div><br><div><br><div>A&nbsp; titre informatif et d’après les informations communiquées par l’entreprise, vous trouverez une simulation du montant de prise en charge, \r</div></div><div>calculée en fonction de l’IDCC : <font color=\"#1472ff\">1486 </font>:&nbsp;&nbsp;</div><div><br><div><table contenteditable=\"false\" id=\"financialTable\" border=\"1\" style=\"border-collapse:collapse;width:100%;text-align:center\"><thead><tr><th contenteditable=\"false\"></th><th contenteditable=\"false\">Montant de la prestation (Net de taxe)</th><th contenteditable=\"false\">Montant du niveau de prise en charge OPCO</th><th contenteditable=\"false\">Reste à charge éventuel de l'entreprise (Net de taxe)</th></tr></thead><tbody><tr><td contenteditable=\"false\">Année 1 de financement </td><td><span data-smartfield=\"[prestation1/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Prestation 1</span></td><td><span data-smartfield=\"[opco1/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant OPCO 1</span></td><td><span data-smartfield=\"[entreprise1/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Entreprise 1</span></td></tr><tr><td contenteditable=\"false\">Année 2 de financement </td><td><span data-smartfield=\"[prestation2/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Prestation 2</span></td><td><span data-smartfield=\"[opco2/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant OPCO 2</span></td><td><span data-smartfield=\"[entreprise2/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Entreprise 2</span></td></tr><tr><td contenteditable=\"false\">Année 3 de financement </td><td><span data-smartfield=\"[prestation3/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Prestation 3</span></td><td><span data-smartfield=\"[opco3/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant OPCO 3</span></td><td><span data-smartfield=\"[entreprise3/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Entreprise 3</span></td></tr><tr><td contenteditable=\"false\">Année 4 de financement </td><td><span data-smartfield=\"[prestation4/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Prestation 4</span></td><td><span data-smartfield=\"[opco4/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant OPCO 4</span></td><td><span data-smartfield=\"[entreprise4/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Montant Entreprise 4</span></td></tr><tr><td contenteditable=\"false\">Total</td><td><span data-smartfield=\"[prestationTotal/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Total Prestation</span></td><td><span data-smartfield=\"[opcoTotal/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Total OPCO</span></td><td><span data-smartfield=\"[entrepriseTotal/]\" contenteditable=\"false\" style=\"user-select:none;background-color:#f3f3f3;border:1px solid #ccc;padding:2px 4px;border-radius:4px;display:inline-block\">Entreprise Total</span></td></tr></tbody></table><div><br><div>Simulation, sous réserve des informations communiquées par l’entreprise afin d’identifier le montant de PEC OPCO*.\r</div><div>* Le montant de la prise en charge étant fixé par l’OPCO, le reste a charge pourra être réévaluer en fonction de celle-ci.&nbsp;</div><div>---<br><div><br><div>En contrepartie des prestations fournies à cette convention, l’OPCO verse à l’Organisme de formation un montant annuel constitué de la \r</div></div></div></div></div><div>somme du niveau de la prise en charge fixé par les branches conformément aux dispositions des articles L. 6332-14 I 1° et R. 6332-25 III du \r</div><div>code du travail et aux éventuels frais annexes.  \r</div><div> \r</div><div><div><br></div></div></div></div></div><div>Dans ce cadre, les factures des frais de formation, accompagnées des certificats de réalisation seront adressées directement à l’OPCO.  \r<br><div><br></div></div><div>La facturation s’effectue au fur et à mesure de l’année de formation. Le délai de paiement de chaque facture y est indiqué. \r<br><div><br></div></div><div>Dans l’hypothèse où l’OPCO ne prendrait pas en charge la totalité du financement de la formation, quel qu’en soit le motif (notamment les \r</div><div>absences qui seraient facturées à titre de dédit commercial), l’entreprise resterait tenue du paiement du coût total de la formation envers \r</div><div>l’Organisme de formation. Dans ce cas, une facture du montant non pris en charge par l’OPCO sera adressée à l’entreprise. \r<br><div><br></div></div><div>La formation est gratuite pour l’apprenti.&nbsp;<br><div><br><div>En cas d’absence de paiement par l’entreprise de tout ou partie d’une facture émise par EPITECH dans le délai prévu ci-avant, ce dernier \r</div></div></div><div>pourra, à sa discrétion, appliquer à l’entreprise les pénalités suivantes au titre des intérêts moratoires, sans préjudices de son droit à \r</div><div>réclamer l’indemnisation de son préjudice lié audit retard de paiement. \r<br><div><br></div></div><div>A défaut de paiement et en application de l’article 441-6 du Code de commerce, il sera appliqué des intérêts de retard dont le taux sera \r</div><div>égal à trois (3) fois le taux d’intérêt légal de l’année en cours et obtenir le remboursement des frais de recouvrement qui sont fixés \r</div><div>conformément à l’article 441-6 du Code de commerce à quarante (40) euros.<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE VII : FRAIS ANNEXES - pendant le temps en Organisme de formation uniquement</span> \r</u></b></div></div></div><div><br><div>Lorsqu’ils sont financés par les CFA, l’OPCO prend en charge une partie de ces frais.&nbsp;<br><div><br><div>Frais hébergement : <font color=\"#1472ff\">NON  \r</font></div></div></div></div><div>Frais restauration : <font color=\"#1472ff\">NON</font><br><div>Premier équipement pédagogique : <font color=\"#1472ff\">NON  \r</font></div></div><div>Frais liés à la mobilité internationale :   \r</div><div>(Informations à destination de l’OPCO de l’entreprise)&nbsp;</div><div> \r</div><div> \r</div><div> \r</div>"
    },
    {
      "id": "page4",
      "text": "<b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE VIII : RESILIATION – CONSEQUENCE DE LA RESILIATION</span> \n</u></b><div><br><div>La présente convention peut être résiliée en cas de manquement contractuel commis par l’une ou l’autre des parties, et ce, dans les \n</div></div><div>conditions prévues aux conditions générales de formation EPITECH.  \n<br><div><br></div></div><div>Elle peut également être résiliée en cas de rupture anticipée ou d’interruption du contrat d’apprentissage soit à la demande du.de la \n</div><div>Bénéficiaire soit à la demande d’EPITECH en raison, par exemple, du non-respect de ses obligations par le. La Bénéficiaire (tel que non\n</div><div>respect du règlement intérieur d’EPITECH), soit enfin à celle de l’Entreprise, cette dernière s’engageant alors à prévenir EPITECH par lettre \n</div><div>recommandée, dès qu’elle en est informée et sous 10 (dix) jours maximum, en notifiant la raison de cette rupture, afin qu’il soit mis un \n</div><div>terme anticipé à la présente convention.   \n<br><div><br></div></div><div>Il est à noter qu’un contrat d’apprentissage ne peut être rompu, en dehors du cas de la rupture anticipée en cas d’obtention du diplôme \n</div><div>(Article L6222-19 du Code du travail), que selon les règles en vigueur (Article L6222-18 du Code du travail, Décret no 2018-1231 du 24 \n</div><div>décembre 2018). Une copie du protocole doit être transmise à EPITECH, et à l’OPCO financeur dont dépend l’Entreprise.  \n<br><div><br></div></div><div>Dans tous les cas de rupture du contrat liant l’apprenti.e et l’entreprise, qu’elle intervienne pendant ou après l’expiration de la période \n</div><div>probatoire (45 jours), entraînant la résiliation de la présente convention, le prix de la formation dû au titre du mois de prise d’effet de ladite \n</div><div>résiliation sera calculé sur la base du nombre d’heures de formation qu’il était prévu de dispenser jusqu’à la fin dudit mois. De ce fait, tout \n</div><div>mois commencé est un mois dû.  \n<br><div><br></div></div><div>En cas d’évènement de force majeure (tel que défini par la jurisprudence française) ne permettant pas à l’Organisme de formation d’assurer \n</div><div>tout ou partie de l’action de formation, celui-ci s’engage à rechercher toute solution permettant dans des conditions raisonnables de coût \n</div><div>et de contraintes d’exploitation de poursuivre l’exécution normale des prestations objet des présentes.  \n<br><div><br></div></div><div>Enfin, EPITECH se réserve le droit d’annuler une inscription, et donc de mettre un terme à la présente convention, dans le cas où les effectifs \n</div><div>inscrits seraient insuffisants, c’est-à-dire inférieurs à 10. Dans ce cas, EPITECH remboursera à l’entreprise la quote-part du prix de la \n</div><div>formation éventuellement déjà payé.&nbsp;<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE IX : CLAUSE SUSPENSIVE<br></span></u></b><div><br><div>L’exécution de la présente convention est soumise au dépôt du contrat par l’OPCO ou la Direccte (L6224-1 du Code du travail). Le contrat \n</div></div></div></div></div><div>d’apprentissage sera transmis par l’employeur à l’OPCO dont il relève, pour prise en charge financière.<br><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE X - CONCILIATION - LITIGES</span></u></b></div></div><div><br><div>En cas de difficultés d’exécution de la présente convention, et avant toute procédure juridictionnelle, chacune des parties s’engage à \n</div><div>désigner deux personnes de sa société, de niveau « Direction générale ».  \n<br><div><br></div></div><div>Ces personnes devront se réunir à l’initiative de la partie la plus diligente dans les huit (8) jours à compter de la réception de la lettre de \n</div><div>demande de réunion de conciliation.  \n<br><div><br></div></div><div>L’ordre du jour est fixé par la partie qui prend l’initiative de la conciliation.  \n<br><div><br></div></div><div>Les décisions, si elles sont arrêtées d’un commun accord, ont valeur contractuelle.  \n<br><div><br></div></div><div>Cette clause est juridiquement autonome de la présente convention. Elle continue à s’appliquer malgré l’éventuelle nullité, résolution, \n</div><div>résiliation ou le possible anéantissement du contrat.  \n<br><div><br></div></div><div>En cas d’échec de la procédure de conciliation, les parties conviennent de mettre en œuvre les dispositions de la clause « Médiation », si \n</div><div>ses conditions d’application sont réunies, et de la clause « Juridiction » des conditions générales de formation EPITECH.&nbsp;</div><div><br><div><b><u><span style=\"font-size: 16px; font-family: Roboto;\">ARTICLE XI - DISPOSITIONS FINALES<br></span></u></b><div><br><div>La présente convention est un contrat accessoire aux conditions générales de formation EPITECH, qu’il complète et auquel il peut, le cas \n</div></div></div></div></div></div><div>échéant, déroger. Dans le silence de la présente convention, ce sont donc les stipulations desdites conditions générales qui s’appliquent. \n</div><div>En cas de contradiction entre la présente convention et lesdites conditions générales, ce sont les stipulations de la présente convention qui \n</div><div>prévalent.&nbsp;&nbsp;<br><div><br><div><b><u></u></b></div></div></div><span style=\"font-size: 16px; font-family: Roboto;\"><div><br></div><div></div></span><div><br></div>"
    },
    {
      "id": "page5",
      "text": "<b><u><span style=\"font-size: 16px; font-family: Roboto;\">Article XII - DATE D’EFFET ET DUREE DE LA CONVENTION<br></span></u></b><div><br><div>La présente convention est applicable pour toute la durée de réalisation de l’action de formation, visée à l’Article I.</div></div>"
    }
  ],
}
export const hoursSchedule = [
  "8h00",
  "9h00",
  "10h00",
  "11h00",
  "12h00",
  "13h00",
  "14h00",
  "15h00",
  "16h00",
  "17h00",
  "18h00",
  "19h00",
]
